import {
  uniq, difference, xor, intersection,
} from 'lodash-es';
import workers from '@/workers/';
import questionEvaluate from '@/utils/questions/questionEvaluate';
import { getInformationIds, getRequiredIds } from '@/utils/questions/questionHelper';
import NorRpn from 'nor-rpn';

const norRpn = new NorRpn();
export default async function displayValidator(pages, questions, answers, originDisplayRules) {
  // 实际答题 = 总题目 - 跳转结束页之后的题目 - 未显示的题目 - 信息栏
  let isPass = true;
  let answerIds = [];
  let expectedAnswerIds = [];
  function findRulesByLeftVal(displayRules, leftVals) {
    return displayRules.filter(rule => rule.expressions.find(expr => leftVals.includes(expr.leftVal)));
  }
  if (originDisplayRules) {
    const questionIds = Object.keys(questions);
    const informationIds = getInformationIds(questions);
    const requiredIds = getRequiredIds(questions);
    const {
      newDisplayRules: displayRules,
      newEndRules: endRules,
    } = await workers.initRule(JSON.stringify({
      rules: originDisplayRules,
      questions,
    }));
    const endRule = endRules.end;
    let saveEndQIds = questionIds;
    let isEnd;
    answerIds = Object.keys(answers);
    if (endRule) {
      const { expressions } = endRule;
      const values = expressions
        .map(expr => questionEvaluate({ questions, answers }, expr.leftVal, expr.operator, expr.rightVal));
      isEnd = norRpn.calculate(endRule.formula, values);
      if (isEnd) {
        let endIndex;
        let endQIds;
        saveEndQIds = [];
        if (endRule.formulaRelation === 'or') {
          endIndex = values.indexOf(true);
          endQIds = [expressions[endIndex].leftVal];
        } else {
          // todo 自定义表达式的情况下可能有问题
          endQIds = expressions.map(expr => expr.leftVal);
        }
        const endQIdCount = endQIds.length;
        let matchCount = 0;
        pages.forEach((item) => {
          if (matchCount < endQIdCount) {
            saveEndQIds = saveEndQIds.concat(item.questions);
            endQIds.forEach((qid) => {
              if (item.questions.includes(qid)) {
                matchCount += 1;
              }
            });
          }
        });
      }
    }
    answerIds.forEach((item) => {
      expectedAnswerIds.push(item);
      const rules = findRulesByLeftVal(displayRules, item);
      rules.forEach((rule) => {
        const values = rule.expressions
          .map(expr => questionEvaluate({ questions, answers }, expr.leftVal, expr.operator, expr.rightVal));
        const isShow = norRpn.calculate(rule.formula, values);
        if (isShow) {
          expectedAnswerIds = expectedAnswerIds.concat(rule.questionIds);
        }
      });
    });
    expectedAnswerIds = uniq(difference(intersection(saveEndQIds, expectedAnswerIds), informationIds));
    // 预期答题数据和实际答题数据都需要排除非必填问题（跟必填题取交集）
    isPass = xor(intersection(expectedAnswerIds, requiredIds), intersection(answerIds, requiredIds)).length <= 0;
  }
  return {
    isPass,
    received: answerIds,
    expected: expectedAnswerIds,
  };
}
